module.exports = __webpack_public_path__ + "static/img/menu_icon.a54b2057.svg";